var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback } from 'react';
import { bodyLoader, hiddenText, loader, loadingAnimation, loaderDot, loaderDotBody, loaderDot1, loaderDot2, message, wrapper, transparentBg, } from '../styles/legacy';
import { bodyLoader as bodyLoaderCitrus2022, hiddenText as hiddenTextCitrus2022, loader as loaderCitrus2022, loadingAnimation as loadingAnimationCitrus2022, loaderDot as loaderDotCitrus2022, loaderDotBody as loaderDotBodyCitrus2022, loaderDot1 as loaderDot1Citrus2022, loaderDot2 as loaderDot2Citrus2022, message as messageCitrus2022, wrapper as wrapperCitrus2022, transparentBg as transparentBgCitrus2022, } from '../styles/citron';
import { citrusStyled } from '@citrus/runtime';
import { getThemeStyle, useTheme } from '@citrus/user';
import { isNotNullOrEmpty } from '@pcty/utils';
import { css, cx } from 'emotion';
var XLoader = citrusStyled.div('loader', { legacy: loader, citrus2022: loaderCitrus2022 });
var LoadingAnimation = citrusStyled.div('loadingAnimation', {
    legacy: loadingAnimation,
    citrus2022: loadingAnimationCitrus2022,
});
var LoaderDot = citrusStyled.div('loaderDot', { legacy: loaderDot, citrus2022: loaderDotCitrus2022 });
var Message = citrusStyled.div('message', { legacy: message, citrus2022: messageCitrus2022 });
var Wrapper = citrusStyled.div('wrapper', { legacy: wrapper, citrus2022: wrapperCitrus2022 });
var HiddenText = citrusStyled.span('hiddenText', { legacy: hiddenText, citrus2022: hiddenTextCitrus2022 });
export var Loader = function (_a) {
    var _b;
    var message = _a.message, transparent = _a.transparent, other = __rest(_a, ["message", "transparent"]);
    var theme = useTheme();
    var style = useCallback(function (legacy, citrus2022) {
        return getThemeStyle(theme, { legacy: legacy, citrus2022: citrus2022 });
    }, [theme]);
    return (React.createElement(XLoader, __assign({ className: cx((_b = {},
            _b[css(style(transparentBg, transparentBgCitrus2022))] = transparent,
            _b)) }, other),
        React.createElement(Wrapper, null,
            !message && React.createElement(HiddenText, null, "Loading..."),
            React.createElement(LoadingAnimation, null,
                React.createElement(LoaderDot, { className: css(style(loaderDot1, loaderDot1Citrus2022)) }),
                React.createElement(LoaderDot, { className: css(style(loaderDot2, loaderDot2Citrus2022)) }),
                React.createElement(LoaderDot, null)),
            showMessage(message))));
};
export var BodyLoader = function (_a) {
    var message = _a.message, other = __rest(_a, ["message"]);
    var theme = useTheme();
    var style = useCallback(function (legacy, citrus2022) {
        return getThemeStyle(theme, { legacy: legacy, citrus2022: citrus2022 });
    }, [theme]);
    var themedLoaderDot1 = style(loaderDot1, loaderDot1Citrus2022);
    var themedLoaderDot2 = style(loaderDot2, loaderDot2Citrus2022);
    var themedLoaderDotBody = style(loaderDotBody, loaderDotBodyCitrus2022);
    return (React.createElement(XLoader, __assign({ className: css(style(bodyLoader, bodyLoaderCitrus2022)) }, other),
        React.createElement(Wrapper, null,
            !message && React.createElement(HiddenText, null, "Loading..."),
            React.createElement(LoadingAnimation, null,
                React.createElement(LoaderDot, { className: css(__assign(__assign({}, themedLoaderDotBody), themedLoaderDot1)) }),
                React.createElement(LoaderDot, { className: css(__assign(__assign({}, themedLoaderDotBody), themedLoaderDot2)) }),
                React.createElement(LoaderDot, { className: css(themedLoaderDotBody) })),
            showMessage(message))));
};
var showMessage = function (message) {
    return isNotNullOrEmpty(message) ? React.createElement(Message, null, message) : undefined;
};
export var Styled = {
    BodyLoader: BodyLoader,
    Loader: Loader,
};
